export default "__VITE_ASSET__D5J2YtiW__"